import type { VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import DetailsPanel from '../../../generic/DetailsPanel';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import { Section } from '../../../shared/vulns/Drawer';
import styles from '../IssueContent.module.less';
import DependencyDepthMessage from '../DependencyDepthMessage';
import { isRiskIssueType } from '../../../../../shared/issuesV2';
import RiskDescription from './RiskDescription';
import BaseQualityDescription from './BaseQualityDescription';
import RiskDocs from './RiskDocs';

/**
 * Main issue details for quality issues.
 *
 * Displays the reason this issue was raised and the depth at which
 * the source package is used.
 */
const QualityIssueDetailsIssueDetails: VoidFunctionComponent = () => {
  const qualityIssueDetails = useSelector(IssuesV2Store.selectors.getQualityIssueDetails);

  if (!qualityIssueDetails) {
    return null;
  }
  const { depthMessages, type, sourceId } = qualityIssueDetails;

  const shouldShowRiskInfo = isRiskIssueType(type);

  return (
    <Section>
      <DetailsPanel id="issue-details-quality-details" target="Issue details">
        <div className={styles.issueDetails}>
          {shouldShowRiskInfo ? (
            <RiskDescription type={type} locator={sourceId} />
          ) : (
            <BaseQualityDescription />
          )}
          {depthMessages && <DependencyDepthMessage depthMessages={depthMessages} />}
          {shouldShowRiskInfo && <RiskDocs type={type} />}
        </div>
      </DetailsPanel>
    </Section>
  );
};

export default QualityIssueDetailsIssueDetails;
